/**
 * AGC: PvE metadata helpers retained for UI rendering while on-chain battle logic lives in backend services.
 * AGC: Supplies rarity styling and strongly typed aliases required by InteractivePvEBattle.
 */
export type Rarity = 'DIAMOND' | 'GOLD' | 'SILVER' | 'BRONZE' | 'NONE'

interface RarityMetadata {
  label: string
  color: string
  description: string
}

/**
 * AGC: Map each rarity tier to deterministic branding colors and descriptive copy for the battle recap.
 */
export const RARITY_INFO: Record<Rarity, RarityMetadata> = {
  DIAMOND: {
    label: 'Diamond',
    color: '#5B8BFF',
    description: 'AGC: Ultra-rare critical surge granting massive damage bonuses.'
  },
  GOLD: {
    label: 'Gold',
    color: '#F7B500',
    description: 'AGC: High rarity strike adding powerful offensive pressure.'
  },
  SILVER: {
    label: 'Silver',
    color: '#C0C0C0',
    description: 'AGC: Respectable rarity delivering balanced damage boosts.'
  },
  BRONZE: {
    label: 'Bronze',
    color: '#CD7F32',
    description: 'AGC: Entry-level rarity offering modest damage increases.'
  },
  NONE: {
    label: 'None',
    color: '#64748B',
    description: 'AGC: No rarity proc occurred during this turn.'
  }
}


